import {
  SET_SELECTED_SURVEY_CATEGORY,
  RESET_SELECTED_SURVEY_CATEGORY,
} from "../utils/constants";

const initialState = {
  studyId: "",
  categoryName: "",
  categoryId: null,
  categoryType: "",
  mappedCategory: "",
  isEditMode: false,
  customRecruits: [],
  budgetedCredits: 0,
  usedCredits: 0,
  isLocked: false,
};

const selectedSurveyCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_SURVEY_CATEGORY:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_SELECTED_SURVEY_CATEGORY:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default selectedSurveyCategoryReducer;
